//socket tài khoản
import _, { isEmpty } from 'lodash';
import io from 'socket.io-client';

import { queueProcessCommon } from '@/utilities/queueProcess';
import Random from '@/utilities/random';
import CommonUtils from '@/utilities/utils';
import { store } from '@/stores/dataStore/reduxStore/store';
import { SocketStatus } from '@/stores/dataStore/memoryStore/const/constIndex';
import { onSetStatusSocket, onSocketAccountAction } from '../Actions/appAction';
import { getConfigFromWindowBrowser } from '@/utilities';
import { ENV } from '@/utilities/EWindow';
const queueProcess = queueProcessCommon()
const TIME_SKIP_EVENT_ACCOUNT = 500
// "CI";
// "OD";
// "SE";
// "PP";
// ///Thay doi thong tin tai khoan
// "CF";
// "logout";
// ///Thay doi ve lenh va vi the
// "DO";
// ///Thay doi ve tien
// "DT";
// ///Cap nhat so lenh dieu kien co so
// "COD";

const API_BASE_URL = getConfigFromWindowBrowser(ENV.BASE_URL) ?? ''

const globalVar = {}

export let sidSocket = undefined
let queueTime = 0 // time call func queue

const timeoutEmit = 500; // timeout phản hồi từ server

const TabID = CommonUtils.getTabID()
let token = null;
let isReloadData = false
const maxReSubSocket = 5 // Tối đa resub
let countReSubSocket: any = {} // count theo từng key là idReSub

let listIdSubReTry: any[] = []

const TAG_NAME = 'socket_pushacc.js.:'

export const socketRoomName = {
    'account': "acc",      //room publish tín hiệu thay đổi balance tiểu khoản
    'customer': "cus",    //room publish thông tin liên quan đến tài khoản (Vd: thông báo đã download báo cáo xong)
    'message': "msg",      //room publish thông điệp, cảnh báo liên quan tới tài khoản, hoặc các tiểu khoản
    'report': "rpt",      //Loại event report bắn chung vào room customer
};

const SDK_INFO = {
    '__sails_io_sdk_version': '1.2.1',
    '__sails_io_sdk_platform': 'browser',
    '__sails_io_sdk_language': 'javascript',
};
//socket tài khoản
const socket = io(API_BASE_URL, {
    path: '/realtime/socket.io',
    // path: '/realtime/socket.io',
    transports: ['websocket'],
    query: SDK_INFO,
    autoConnect: false
});

const operationsQueue: any[] = [];
const subscribedTopics: any[] = [];
const registeredTopics: any = {};
const registeredCalledIds: any = {};
let statusConnectSocket = "connecting"

const reSubSocket = (topics: any[], data: any) => {
    // return null; // Tạm chặn logic resub chờ check log server Socket vì sao trả ra chậm.
    if (statusConnectSocket !== "connected") {
        // reconnectSocketHandler()
        return null;
    }
    let idReSub = data && data.idSub || undefined
    if (!idReSub) return null;
    if (countReSubSocket[idReSub] > maxReSubSocket) {
        // reconnectSocketHandler()
        return null;
    }
    if (countReSubSocket[idReSub]) {
        countReSubSocket[idReSub] = countReSubSocket[idReSub] + 1
    } else {
        countReSubSocket[idReSub] = 1
    }
    let _index = _.findIndex(listIdSubReTry, (item) => { return item === idReSub })
    if (_index == -1) {
        listIdSubReTry.push(idReSub)
    }
    let _subscribedTopics = Object.keys(registeredTopics) || []
    // logDebug("socket_pushacc.:reSubSocket().:topics=", { topics, _subscribedTopics })
    if (!registeredTopics || isEmpty(registeredTopics)) {
        return false;
    }
    let _topics: any[] = []
    _.map(topics, (topic) => {
        if (_subscribedTopics.indexOf(topic) > -1) {
            _topics.push(topic)
        }
    })
    if (_topics && _topics.length > 0) {
        _subscribeToTopics(_topics, idReSub, countReSubSocket[idReSub])
    }
    return null;
}

const _subscribeToTopics = (topics: any[], idReSub?: string, countReSub?: number) => {
    let idSub = idReSub || new Date().getTime() + "_" + Random.randomIdChars(6)
    if (!topics || topics.length === 0) {
        return false;
    }

    if (!socket.connected) {
        //console.log(TAG_NAME + 'Socket not ready, topics will be subscribe later');
        return false;
    }

    let state, tabId, SID_socket;
    token = CommonUtils.getTokenCurr()
    tabId = TabID
    SID_socket = sessionStorage.getItem("sidSocketCurr")
    let timeSub = new Date().getTime()
    let data = {
        op: 'subscribe',
        args: topics,
        token: token?.access_token,
        tabId: tabId,
        idSub: idSub,
        timeSub: timeSub,
        SID_socket,
        countReSub,

        timeRes: 0,
        isReloadData: false,
        IsActiveTabBrowser: '',
    }
    timeSub = new Date().getTime()
    data.timeSub = timeSub
    // https://socket.io/docs/v4/client-api/
    socket.timeout(timeoutEmit).emit("get", {
        url: '/client/send',
        method: 'get',
        headers: {

        },
        data: data
    }, (err: any, response: any) => {
        let timeRes = new Date().getTime() - timeSub
        data.timeRes = timeRes
        data.isReloadData = isReloadData
        if (err) {
            state = store.getState();
            let IsActiveTabBrowser = state.app.isActiveTabBrowser
            data.IsActiveTabBrowser = IsActiveTabBrowser
            // the server did not acknowledge the event in the given delay
            // reconnectSocketHandler(0)
            reSubSocket(topics, data)
            return false;
        }
        if (response.statusCode === 200) {
            //console.log(TAG_NAME + 'Subscribed to topics ' + topics.join(', '));
        } else {
            //console.log(TAG_NAME + 'Fail to subscribe to topics ' + topics.join(', '));
        }
    }
    );

    return true;
};

const _unsubscribeFromTopics = (topics: any[], idReSub?: string) => {
    let idSub = idReSub || new Date().getTime() + "_" + Random.randomIdChars(6)
    if (!topics || topics.length === 0) {
        return;
    }

    if (!socket.connected) {
        //console.log(TAG_NAME + 'Socket not ready, unsubscribe is skipped');
        return;
    }
    let state, tabId, SID_socket;
    token = CommonUtils.getTokenCurr()
    let timeSub = new Date().getTime()
    let data = {
        op: 'unsubscribe',
        args: topics,
        token: token?.access_token,
        tabId: tabId,
        idSub: idSub,
        timeSub: timeSub,
        SID_socket,

        IsActiveTabBrowser: '',
        timeRes: 0,
        isReloadData: false,
    }
    timeSub = new Date().getTime()
    data.timeSub = timeSub
    socket.timeout(timeoutEmit).emit("get", {
        url: '/client/send',
        method: 'get',
        headers: {},
        data: data
    }, (err: any, response: any) => {
        let timeRes = new Date().getTime() - timeSub
        data.timeRes = timeRes
        data.isReloadData = isReloadData
        if (err) {
            state = store.getState();
            let IsActiveTabBrowser = state.app.isActiveTabBrowser
            data.IsActiveTabBrowser = IsActiveTabBrowser
            // the server did not acknowledge the event in the given delay
            // reconnectSocketHandler(0)
            // reSubSocket(topics, data)
            return false;
        }
        if (response.statusCode === 200) {
            //console.log(TAG_NAME + 'Subscribed to topics ' + topics.join(', '));
        } else {
            //console.log(TAG_NAME + 'Fail to subscribe to topics ' + topics.join(', '));
        }
    }
    );
};

// Clear callerId with empty topic and clear topic with empty callerId
const _prunce = () => {
    const willBeDeleteTopics: any[] = [];
    _.forIn(registeredTopics, (callerIds: [], topic) => {
        if (!callerIds || callerIds.length === 0) {
            willBeDeleteTopics.push(topic);
        }
    });
    _.forEach(willBeDeleteTopics, (topic: string) => {
        delete registeredTopics[topic];
    });

    const willBeDeleteCallerIds: any = [];
    _.forIn(registeredCalledIds, (topics: [], callerId) => {
        if (!topics || topics.length === 0) {
            willBeDeleteCallerIds.push(callerId);
        }
    });
    _.forEach(willBeDeleteCallerIds, (callerId) => {
        delete registeredCalledIds[callerId];
    });
};

const _clearSubscribedTopics = () => {
    subscribedTopics.length = 0;
};

const _registerTopic = (topic: string, callerId: string) => {
    if (registeredTopics.hasOwnProperty(topic)) {
        const callerIds = registeredTopics[topic];
        if (!_.includes(callerIds, callerId)) {
            callerIds.push(callerId);
        }
    } else {
        registeredTopics[topic] = [callerId];
    }

    if (registeredCalledIds.hasOwnProperty(callerId)) {
        const topics = registeredCalledIds[callerId];
        if (!_.includes(topics, topic)) {
            topics.push(topic);
        }
    } else {
        registeredCalledIds[callerId] = [topic];
    }
};

const _unregisterTopic = (topic: string, callerId?: string) => {
    if (registeredTopics.hasOwnProperty(topic)) {
        const callerIds = registeredTopics[topic];
        _.remove(callerIds, (element) => {
            return callerId === element;
        });
    }

    if (registeredCalledIds.hasOwnProperty(callerId) && callerId) {
        const topics = registeredCalledIds[callerId];
        _.remove(topics, (element) => {
            return topic === element;
        });
    }
};

const _unregisterTopics = (topics: any[], callerId?: string, dontCallApply?: boolean) => {
    if (topics && topics.length > 0) {
        for (let i = 0; i < topics.length; i++) {
            _unregisterTopic(topics[i], callerId);
        }
    }

    _prunce();

    if (!dontCallApply) {
        _apply();
    }
};

const _unregisterCallerId = (callerId: string, dontCallApply: boolean) => {
    if (registeredCalledIds.hasOwnProperty(callerId)) {
        const topics = registeredCalledIds[callerId];
        if (topics && topics.length > 0) {
            _unregisterTopics([...topics], callerId, dontCallApply);
        }
    }
};

const _registerTopics = (topics: any[], callerId: string) => {
    // Unregister all topic previously registered by this callerId
    _unregisterCallerId(callerId, true);

    if (topics && topics.length > 0) {
        for (let i = 0; i < topics.length; i++) {
            _registerTopic(topics[i], callerId);
        }
    }

    _apply();
};

const _apply = () => {
    const needToSubscribeTopics: any[] = [];
    _.forIn(registeredTopics, (callerIds, topic) => {
        if (callerIds.length > 0) {
            needToSubscribeTopics.push(topic);
        }
    });

    const willBeSubscribeTopics = _.difference(needToSubscribeTopics, subscribedTopics);
    const willBeUnSubscribeTopics = _.difference(subscribedTopics, needToSubscribeTopics);

    if (_subscribeToTopics(willBeSubscribeTopics)) {
        _.forEach(willBeSubscribeTopics, (topic: any) => {
            if (!_.includes(subscribedTopics, topic)) {
                subscribedTopics.push(topic);
            }
        });
    }

    _unsubscribeFromTopics(willBeUnSubscribeTopics);
    _.forEach(willBeUnSubscribeTopics, (topic) => {
        if (_.includes(subscribedTopics, topic)) {
            _.remove(subscribedTopics, (element) => {
                return element === topic;
            });
        }
    });
};

const _scheduleToExecuteOperations = () => {
    let timer = setTimeout(() => { _executeOperations(); clearTimeout(timer) }, 100);
};

const _executeOperation = (operation: any) => {
    const { action, data } = operation;
    switch (action) {
        case 're-subscribe':
            _apply();
            break;
        case 'clear-subscribed':
            _clearSubscribedTopics();
            break;
        case 'register': {
            const { topics, callerId } = data;
            _registerTopics(topics, callerId);
            break;
        }
        case 'unregister': {
            const { topics, callerId } = data;
            _unregisterTopics(topics, callerId);
            break;
        }
        case 'unregister-callerId': {
            const { callerId } = data;
            _unregisterCallerId(callerId, false);
            break;
        }
        default:
            //console.log(TAG_NAME + 'Unknown socket action ' + action);
            break;
    }
};

const _executeOperations = () => {
    while (operationsQueue.length > 0) {
        const operation = operationsQueue.shift();
        _executeOperation(operation);
    }
    _scheduleToExecuteOperations();
};

const _requestReSubscribeToAllSubscribedTopics = () => {
    let context = {
        action: 're-subscribe'
    }
    queueProcess.add(_executeOperation, context, queueTime)
};

const _requestClearSubscribedTopics = () => {
    let context = {
        action: 'clear-subscribed'
    }
    queueProcess.add(_executeOperation, context, queueTime)
};

// Fired upon a connection including a successful reconnection
socket.on('connect', () => {
    //console.log(TAG_NAME + 'Socket connected');
    onSetStatusSocket(SocketStatus.CONNECTED)
    _requestReSubscribeToAllSubscribedTopics();
});

// Fired upon a disconnection including a abnormal disconnection
socket.on('disconnect', () => {
    //console.log(TAG_NAME + 'Socket disconnected');
    _requestClearSubscribedTopics();
    onSetStatusSocket(SocketStatus.DISCONNECTED)
});


socket.on(socketRoomName.account, (message) => {
    if (message.d.length > 0) {
        let { ACC: accountId, DT: type, row } = message.d[0];
        console.log('ha_check_socketRoomNameAccount', message)
        if (row && row.length) {
            onSocketAccountAction(accountId, type, row)
        }
    }
});

// socket.on(socketRoomName.customer, (message) => {
//     if (message.d.length > 0) {
//         const { DT: type } = message.d[0];

//         if (type == 'CF') dispatch(actions.changeCustomerInfoEventtype(message));
//         else if (type == 'AFU') {
//             userService.getPermissionInfo().then((data) => { }).catch(error => { }) //giang.ngo: gọi lại hàm getPermissionInfo để cập nhật lại thông tin permissioninfo của tài khoản
//             dispatch(actions.changeAccountInfoEventtype(message));
//         } else {
//             let { CUSTID: custid } = message.d[0];
//             dispatch(actions.onSocketCustomerAction(custid, type));

//         };
//     }
// });

// socket.on(socketRoomName.report, (message) => {
//     let reportKeys = getValueFromSessionStorage(sessionKeyFactory.reportKeys);
//     if (reportKeys) {
//         reportKeys = JSON.parse(reportKeys);
//     } else reportKeys = {};
//     if (message.d.length > 0) {
//         const { autoid, fekey } = message.d[0];
//         if (autoid) {
//             if (fekey != null && !reportKeys[fekey]) return;
//             delete reportKeys[fekey];
//             inquiryService.getReport(autoid);
//         }
//     }
// });

// socket.on("logout", (message) => {
//     const token = CommonUtils.getTokenCurr()
//     const { CLIENTID, REASON, ACCESS_TOKEN } = message;
//     if (CLIENTID == "*" || CLIENTID == globalVar.api.CLIENT_ID) {
//         if (REASON == "KILL_SESSION") {
//             //ko đá bản thân
//             if (token !== ACCESS_TOKEN) {
//                 dispatch(actions.logoutByOther());
//             };
//         } else if (REASON == "CHANGE_PASS") {
//             dispatch(actions.changePassWordInfoEventtype(message))
//         }
//     }
// });

// socket.on(socketRoomName.message, (message) => {
//     // dispatch(actions.updateAccountNotifyList());
//     dispatch(actions.updateAccountNotifyCounter());
// });


export const on = (eventName: string, eventHandler: any) => {
    socket.on(eventName, (data) => {
        eventHandler(data);
    })
};

export const connect = () => {
    onSetStatusSocket(SocketStatus.CONNECTING)
    statusConnectSocket = "connected"
    //console.log(TAG_NAME + 'Socket connecting');
    socket.open();
};

export const disconnect = () => {
    statusConnectSocket = "disconnect"
    onSetStatusSocket(SocketStatus.DISCONNECTED)
    return socket.close();
};


// socket.on('connect_error', err => {
//     statusConnectSocket = "connect_error"
//     dispatch(actions.setSocketConnectStatus(SocketStatus.ERROR));
// });

// socket.on('connect_failed', err => {
//     statusConnectSocket = "connect_failed"
//     dispatch(actions.setSocketConnectStatus(SocketStatus.ERROR));
// });

// socket.io.on("reconnect_attempt", (attempt) => {
//     statusConnectSocket = "reconnect_attempt"
//     dispatch(actions.setSocketConnectStatus(SocketStatus.WARNING));
// });

// socket.io.on("reconnect_error", (error) => {
//     statusConnectSocket = "reconnect_error"
//     dispatch(actions.setSocketConnectStatus(SocketStatus.ERROR));
// });

// socket.io.on("reconnect_failed", (err) => {
//     statusConnectSocket = "reconnect_failed"
//     dispatch(actions.setSocketConnectStatus(SocketStatus.ERROR));
// });

// socket.on('reconnecting', () => {
//     statusConnectSocket = "reconnecting"
//     dispatch(actions.setSocketConnectStatus(SocketStatus.CONNECTING));
// });

const timerReconnect = 100
const maxRetryReconnectSocket = 20
let countRetryReconnectSocket = 0
function reconnectSocketHandler() {
    countRetryReconnectSocket++
    console.debug("reconnectSocketHandler.:", countRetryReconnectSocket, statusConnectSocket)
    let timerInc = timerReconnect * countRetryReconnectSocket
    if (countRetryReconnectSocket > 0 && countRetryReconnectSocket <= 5) {
        // ưu tiên 5 lần đầu connect nhanh 
        timerInc = 50
    }
    if (countRetryReconnectSocket <= maxRetryReconnectSocket) {
        // giảm tốc độ của việc reconect
        let timer = setTimeout(function () {
            disconnect()
            connect()
            clearTimeout(timer)
        }, timerInc)
    }
}

export const registerTopics = (topics: string[], callerId: string) => {
    if (!callerId) {
        console.error('CallerId need when register interested topics');
        return;
    }
    let context = {
        action: 'register',
        data: {
            topics: topics,
            callerId: callerId
        }
    }
    queueProcess.add(_executeOperation, context, queueTime)
};

export const unregisterTopics = (topics: [], callerId: string) => {
    if (!callerId) {
        console.error('CallerId need when unregister interested topics');
        return;
    }
    let context = {
        action: 'unregister',
        data: {
            topics: topics,
            callerId: callerId
        }
    }
    queueProcess.add(_executeOperation, context, queueTime)
};

export const unregisterCallerId = (callerId: string) => {
    if (!callerId) {
        console.error('CallerId need when unregister interested topics');
        return;
    }
    let context = {
        action: 'unregister-callerId',
        data: {
            callerId: callerId
        }
    }
    queueProcess.add(_executeOperation, context, queueTime)
};

export const registerAccountTopics = (accountId: string, callerId: string) => {
    registerTopics([socketRoomName.account + ':' + accountId], callerId);
};
export const registerAllAccountTopics = (accountIds: any[], callerId: string) => {
    var subcribeAccounts: any = []
    accountIds.forEach((accountId: string) => {
        subcribeAccounts.push([socketRoomName.account + ':' + accountId])
    })
    registerTopics(subcribeAccounts, callerId);
};
export const registerCustomerTopics = (custid: string, callerId: string) => {
    registerTopics([socketRoomName.customer + ':' + custid], callerId);
};
export const registerAccountMessageTopics = (custid: string, callerId: string) => {
    registerTopics([socketRoomName.message + ':' + custid], callerId);
};



_scheduleToExecuteOperations();